import { render, staticRenderFns } from "./index.vue?vue&type=template&id=9dc0b78e"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=9dc0b78e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Banner: require('/salonhomepage/client/components/Banner.vue').default,RecEngineModule: require('/salonhomepage/client/components/RecEngineModule.vue').default,LandingPageNews: require('/salonhomepage/client/components/LandingPageNews.vue').default,Giftcard: require('/salonhomepage/client/components/Giftcard.vue').default})
